import { createSelector } from '@reduxjs/toolkit';
import { GlobalState } from '@/redux/store';

const stateSelector = (state: Partial<GlobalState>) => state;
const auctionsNearMeSlice = createSelector(stateSelector, (state) => state.auctionsNearMe);

/**
 * @deprecated: Algolia selector (will be removed post-migration to catalog-management API)
 */
export const getSsrAuctionsNearMeHitsSelector = createSelector(auctionsNearMeSlice, ({ hits }) => hits);

// New catalog-management API selectors
export const getCatalogIdsSelector = createSelector(auctionsNearMeSlice, ({ catalogIds }) => catalogIds);

export const getCatalogsNearMeSelector = createSelector(
    auctionsNearMeSlice,
    ({ catalogsNearMe }) => catalogsNearMe ?? []
);

export const getRelatedGeoAreasSelector = createSelector(auctionsNearMeSlice, ({ otherPlaces }) => otherPlaces ?? []);

export const getPaginationInfoSelector = createSelector(
    auctionsNearMeSlice,
    ({ currentPage, pageSize, totalPages, totalRecords }) => ({
        currentPage,
        pageSize,
        totalPages,
        totalRecords,
    })
);

export const getLoadingSelector = createSelector(auctionsNearMeSlice, ({ loading }) => loading);

export const getErrorSelector = createSelector(auctionsNearMeSlice, ({ error }) => error);
